var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Grid, IconButton, Typography, useMediaQuery } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid-premium';
import { useEffect, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { BackFrontCamera, BlackBackFrontCamera } from '../../../assets/images';
import { showNotification } from '../../../redux/commonSlice';
import { useAppDispatch } from '../../../store/hooks';
import { MuiButton } from '../../atoms/buttonComponent';
import { MuiImagePopUp } from '../../atoms/imageDialogBox';
import { MuiStack } from '../../atoms/stackComponent';
import { MuiPopup } from '../../molecules/popupComponent';
import { t } from 'i18next';
import { red } from '../../../theme/palette';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { GoogleAnlyticsErrorLog, isExeOrJsFile } from '../../../utils/utils';
import { Buffer } from "buffer";
export default function ImageCapture(props) {
    var _this = this;
    var _a = useState([]), complaintsPhotographList = _a[0], setcomplaintsPhotographList = _a[1];
    var _b = useState(false), isCaptureEnable = _b[0], setCaptureEnable = _b[1];
    var _c = useState([]), removedImages = _c[0], setRemovedImages = _c[1];
    var _d = useState('environment'), facingMode = _d[0], setFacingMode = _d[1];
    var _e = useState(false), isDrawerOpen = _e[0], setISDrawerOpen = _e[1];
    var _f = useState(""), imageURL = _f[0], setImageURL = _f[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('lg'); });
    var medium = useMediaQuery('(min-width:830px) and (max-width:1024px)');
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var above1920x1080 = useMediaQuery('(min-width:1920px) and (min-height:1080px)');
    var fileInputRef = useRef(null);
    var webcamRef = useRef(null);
    var dispatch = useAppDispatch();
    var prevDownloadedImagesRef = useRef(props.downloadedImages);
    var videoConstraints = {
        facingMode: facingMode,
        screenshotQuality: 0.2
    };
    useEffect(function () {
        if (props.isRejected) {
            setcomplaintsPhotographList(props.downloadedImages);
        }
        else {
            setcomplaintsPhotographList([]);
        }
    }, [props.isRejected, props.downloadedImages]);
    useEffect(function () {
        var prevDownloadedImages = prevDownloadedImagesRef === null || prevDownloadedImagesRef === void 0 ? void 0 : prevDownloadedImagesRef.current;
        if ((prevDownloadedImages === null || prevDownloadedImages === void 0 ? void 0 : prevDownloadedImages.length) > 0 && props.downloadedImages.length === 0) {
            setcomplaintsPhotographList([]);
        }
        else if (props.downloadedImages.length > 0) {
            setcomplaintsPhotographList(props.downloadedImages);
        }
        prevDownloadedImagesRef.current = props.downloadedImages;
    }, [props.downloadedImages]);
    var handleConfirmClick = function () {
        props.handleClose(false);
        props.handleImageList(complaintsPhotographList, removedImages);
    };
    var onClickRemovePhotoIcon = function (photoIndex) {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        var updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
        var imageItemToDelete = updatedComplaintList[photoIndex];
        if (imageItemToDelete.attachmentId) {
            var updatedImagesToRemove = __spreadArray([], removedImages, true);
            updatedImagesToRemove.push(imageItemToDelete);
            setRemovedImages(updatedImagesToRemove);
        }
        updatedComplaintList.splice(photoIndex, 1);
        setcomplaintsPhotographList(updatedComplaintList);
    };
    var openCamera = function () {
        // setOpen(false)
        setCaptureEnable(true);
    };
    var openFileInput = function (e) {
        e.preventDefault();
        // setOpen(false)
        if (fileInputRef !== null && fileInputRef !== void 0 && fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    // converted base64 URL to file
    function dataURLtoFile(dataurl, filename) {
        var _arr$;
        var arr = dataurl.split(','), mime = (_arr$ = arr[0]) === null || _arr$ === void 0 || (_arr$ = _arr$.match(/:(.*?);/)) === null || _arr$ === void 0 ? void 0 : _arr$[1], bstr = atob(arr[arr.length - 1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {
            type: mime
        });
    }
    var capture = function () {
        var _webcamRef$current;
        var imageSrc = (_webcamRef$current = webcamRef.current) === null || _webcamRef$current === void 0 ? void 0 : _webcamRef$current.getScreenshot();
        if (imageSrc) {
            var updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
            var convertedFile = dataURLtoFile(imageSrc, "image-".concat(new Date().toISOString(), ".png"));
            var imageSizeInBytes = convertedFile.size;
            if (imageSizeInBytes > 5 * 1024 * 1024) {
                GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("File size exceeds 5 MB. Please choose a smaller file"));
                dispatch(showNotification({
                    isOpen: true,
                    message: t("File size exceeds 5 MB. Please choose a smaller file"),
                    type: "error"
                }));
                return;
            }
            updatedComplaintList.push({
                blobUrl: imageSrc,
                file: convertedFile
            });
            setcomplaintsPhotographList(updatedComplaintList);
            setCaptureEnable(false);
        }
    };
    var handleFileChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var allowedExtensions, _i, _a, file, extension, fileSizeInMB, arrayBuffer, buffer, error_1, updatedComplaintList;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    allowedExtensions = ['.png', '.jpeg', '.jpg'];
                    _i = 0, _a = e.target.files;
                    _b.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 6];
                    file = _a[_i];
                    extension = ".".concat(file.name.split('.').pop().toLowerCase());
                    // Check file extension
                    if (!allowedExtensions.includes(extension)) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("Only PNG, JPEG, JPG files are allowed."));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Only PNG, JPEG, JPG files are allowed."),
                            type: "error"
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    fileSizeInMB = file.size / 1024 / 1024;
                    if (fileSizeInMB >= 5) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("File size exceeds 5 MB. Please choose a smaller file"));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("File size exceeds 5 MB. Please choose a smaller file"),
                            type: "error"
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, file.arrayBuffer()];
                case 3:
                    arrayBuffer = _b.sent();
                    buffer = Buffer.from(new Uint8Array(arrayBuffer));
                    if (isExeOrJsFile(buffer)) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("The file format is invalid and not allowed."),
                            type: "error"
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    console.error('Error processing file:', error_1);
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Error processing file. Please try again."),
                        type: "error"
                    }));
                    e.target.value = '';
                    return [2 /*return*/];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6:
                    updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
                    updatedComplaintList.push({
                        file: e.target.files[0],
                        blobUrl: URL.createObjectURL(e.target.files[0])
                    });
                    setcomplaintsPhotographList(updatedComplaintList);
                    // Clear the file input
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var closedImagePopUp = function () {
        if (props.downloadedImages) {
            setcomplaintsPhotographList(props.downloadedImages);
        }
        props.handleClose(false);
    };
    var switchCamera = function () {
        setFacingMode(function (prevFacingMode) { return prevFacingMode === 'user' ? 'environment' : 'user'; });
    };
    var handleClose = function () {
        setImageURL("");
        setISDrawerOpen(false);
    };
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: props.isOpen,
        title: t("Add Photos")
        // subTitle="Please add photos for the complaint"
        // subTitleVariant='h4'
        ,
        variant: "h1",
        onClose: function () { return closedImagePopUp(); },
        closeIcon: true
        // paddingTop='10px'
        ,
        containerStyle: {
            "&.MuiDialogContent-root": {
                padding: "0px",
                width: above1920x1080 ? 'calc(23vw)' : isDesktop ? 'calc(31vw)' : medium ? 'calc(58vw)' : lgMode ? 'calc(64vw)' : 'calc(80vw)'
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 3,
        direction: 'column',
        paddingX: 3,
        paddingBottom: 3
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: "#8593A3"
        }
    }, t("Please add photos for the complaint"))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            color: red
        }
    }, "*" + t("FILE_SIZE_MESSAGE"))), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "camera-btn",
        name: t('Camera'),
        size: "medium",
        style: {
            border: '1px solid #DEE4EB'
        },
        fullWidth: true,
        onClick: openCamera,
        disabled: complaintsPhotographList && complaintsPhotographList.length == 3
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "gallary-btn",
        name: t('Gallery'),
        size: "medium",
        style: {
            border: '1px solid #DEE4EB'
        },
        fullWidth: true,
        onClick: openFileInput,
        disabled: complaintsPhotographList && complaintsPhotographList.length == 3
    })), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        justifyContent: 'space-between',
        display: 'flex',
        alignContent: 'center'
    }, complaintsPhotographList === null || complaintsPhotographList === void 0 ? void 0 : complaintsPhotographList.map(function (item, photoIndex) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        key: photoIndex,
        xs: 4,
        sm: 4,
        md: 4,
        lg: 4
    }, /*#__PURE__*/ React.createElement("div", {
        className: "1st",
        style: {
            position: 'relative',
            display: 'inline-block'
        }
    }, /*#__PURE__*/ React.createElement(GridCloseIcon, {
        id: "close-icon",
        onClick: function () { return onClickRemovePhotoIcon(photoIndex); },
        sx: {
            position: 'absolute',
            zIndex: 1,
            right: 4,
            top: 4,
            backgroundColor: "white",
            height: '15px',
            width: '15px',
            borderRadius: 50
        }
    }), /*#__PURE__*/ React.createElement("img", {
        src: item.blobUrl,
        alt: "Image ".concat(photoIndex + 1),
        style: {
            width: '72px',
            height: '72px',
            borderRadius: '8px',
            position: 'relative'
        },
        onClick: function () { return handleClickImage(item.blobUrl); }
    }))); })), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: imageURL
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2,
        marginTop: 10
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "confirm-btn",
        name: t('Confirm'),
        size: "medium",
        fullWidth: true,
        variant: "contained",
        onClick: handleConfirmClick,
        disabled: !((complaintsPhotographList === null || complaintsPhotographList === void 0 ? void 0 : complaintsPhotographList.length) > 0)
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "cancel-btn",
        name: t('Cancel'),
        size: "medium",
        fullWidth: true,
        onClick: function () { return closedImagePopUp(); }
    })))), isCaptureEnable && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: isCaptureEnable,
        borderRadius: 0,
        containerStyle: {
            padding: '0'
            // width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            position: 'relative',
            padding: '0px',
            overflow: 'hidden'
            // width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(Webcam, {
        audio: false,
        width: medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)',
        height: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)',
        ref: webcamRef,
        screenshotFormat: "image/jpeg",
        videoConstraints: videoConstraints
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        sx: {
            position: 'absolute',
            padding: '10px',
            backgroundColor: 'white',
            bottom: 3,
            width: "100%"
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        id: "switch-camera-icon",
        onClick: switchCamera
    }, facingMode == "user" ? /*#__PURE__*/ React.createElement("img", {
        src: BlackBackFrontCamera,
        alt: "camera"
    }) : /*#__PURE__*/ React.createElement("img", {
        src: BackFrontCamera,
        alt: "camera"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        gap: '10px'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "close-btn",
        name: t("Close"),
        onClick: function () { return setCaptureEnable(false); }
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "capture-btn",
        name: t("Capture"),
        onClick: capture
    }))))), /*#__PURE__*/ React.createElement("input", {
        id: "upload-image",
        type: "file",
        ref: fileInputRef,
        style: {
            display: 'none'
        },
        onChange: handleFileChange,
        accept: "image/*"
    }));
}
